module.exports = __webpack_public_path__ + "img/SitePlaceHolder.a1643c4c.jpg";